export default "__VITE_ASSET__CueWZB0G__"